import { clientBase } from "../common";

export const logout = () => {
  return clientBase(`v1/logout`, "POST");
};
